import {useRole} from "../hooks/useMe";
import {useState} from 'react';
import {useQueryClient} from '@tanstack/react-query';
import {Button} from '@aiw/ui';
import {useSavedReport} from '../hooks/useReads';
import {useT} from '../i18n';
import {useFileReport} from '../lib/report';
import {AnswerLine,useAnswer} from './Answer';
export function WorkAcceptance({jobRef,installation}:{jobRef:string;installation:string|null|undefined}){
 const {isExternal}=useRole();
 const fileReport=useFileReport();
 const {t}=useT(),state=useSavedReport(jobRef,installation),cache=useQueryClient(),{answer,say}=useAnswer();const [busy,setBusy]=useState(false);
 async function accept(){if(!state.data||busy)return;setBusy(true);try{const r=await fileReport({job_ref:jobRef,installation_id:state.data.installation_id,party_id:state.data.party_id,kind:'accept'});say(r);if(r.status==='executed')await cache.invalidateQueries({queryKey:['installer-report-state',jobRef]});}catch{say('failed');}finally{setBusy(false);}}
 return <div className="rounded-lg border bg-card p-4 space-y-3">
  <p className="text-sm">{state.isLoading?t('loading'):!state.data?t('saved_report_unavailable'):state.data.accepted?t(isExternal?'saved_work_accepted':'saved_report_ready'):t('saved_work_needs_acceptance')}</p>
  {state.data&&!state.data.accepted&&<Button size="touch" disabled={busy} onClick={()=>void accept()}>{t('accept_this_work')}</Button>}
  <AnswerLine answer={answer}/>
 </div>;
}
